import { AttachMoney, Percent } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import { Surplus } from 'lib/api/reports/types';
import { formatMoney, formatPercentage } from 'lib/functions/utils';
import React from 'react';

import InfoRow from './InfoRow';

interface SurplusRetainedSectionProps {
  surplus: Surplus;
}

const SurplusRetainedSection: React.FC<SurplusRetainedSectionProps> = ({
  surplus,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          backgroundColor: 'rgba(156, 39, 176, 0.08)',
          borderRadius: '8px',
          px: 1.5,
          py: 0.8,
          border: '1px solid rgba(156, 39, 176, 0.15)',
          mt: 1,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            color: 'purple',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'center',
          }}
        >
          Excedente Retenido
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <InfoRow
            label="Porcentaje Retenido"
            value={formatPercentage(surplus.retainedPercentage.toString())}
            maxLength={40}
            icon={<Percent sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Monto Retenido"
            value={formatMoney(surplus.retainedAmount)}
            maxLength={40}
            icon={<AttachMoney sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Monto Disponible A Liberar"
            value={formatMoney(surplus.availableSurplus)}
            maxLength={40}
            icon={<AttachMoney sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InfoRow
            label="Monto Reducido Por Mora"
            value={formatMoney(surplus.surplusReducedByArrear)}
            maxLength={40}
            icon={<AttachMoney sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Monto Reducido Por Documento"
            value={formatMoney(surplus.surplusReducedByDocument)}
            maxLength={40}
            icon={<AttachMoney sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
          <InfoRow
            label="Monto Reducido Total"
            value={formatMoney(
              surplus.surplusReducedByArrear + surplus.surplusReducedByDocument,
            )}
            maxLength={40}
            icon={<AttachMoney sx={{ fontSize: '0.8rem', color: 'purple' }} />}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SurplusRetainedSection;
